import {configureStore} from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import roleReducer from './slices/roleSlice';
import financeSlice from './slices/financeSlice';
import permissionReducer from './slices/permissionSlice';
import productReducer from './slices/productSlice';
import categoryReducer from './slices/categorySlice';
import orderReducer from './slices/orderSlice';
import systemReducer from './slices/systemSlice';
import brandReducer from './slices/brandSlice';
import specificationReducer from './slices/specificationSlice';
import merchantReducer from './slices/merchantSlice';
import recycleCategoryReducer from './slices/recycleCategorySlice';
import recycleOrderReducer from './slices/recycleOrderSlice';
import recycleLogisticReducer from './slices/recycleLogisticSlice';
import recycleValuationReducer from './slices/recycleValuationSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    role: roleReducer,
    permission: permissionReducer,
    product: productReducer,
    category: categoryReducer,
    order: orderReducer,
    system: systemReducer,
    brand: brandReducer,
    specification: specificationReducer,
    merchant: merchantReducer,
    finance: financeSlice,
    recycleCategory: recycleCategoryReducer,
    recycleOrder: recycleOrderReducer,
    recycleLogistic: recycleLogisticReducer,
    recycleValuation: recycleValuationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
